import { createFileRoute } from '@tanstack/react-router';
import { FlowsPage } from '@/modules/flows/public';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/centuria/fluxos/')({
  component: function FlowsRoute() {
    const navigate = Route.useNavigate();
    return (
      <RequirePermission anyOf={['centuria.fluxos']}>
        <FlowsPage onOpen={(flowId) => navigate({ to: '/centuria/fluxos/$flowId', params: { flowId } })} />
      </RequirePermission>
    );
  },
});
